import type { ProductsQueryQuery } from '@generated/graphql'

import type { ProductSummary_VariantFragment } from '../../@generated/graphql/index'

type Products = ProductsQueryQuery['search']['products']['edges']

type Variations = ProductSummary_VariantFragment[]

export const filterAvailableVariations = (variations: Variations) => {
  return variations.filter((variation) => {
    return variation.offers.offers.some((offer) => {
      return offer.availability === 'https://schema.org/InStock'
    })
  })
}

/**
 * @param products
 * @returns array of available products
 *
 * This function verifies if the product has stock, if don't,
 * verifies if some of the variations of the product have stock.
 */
export const filterAvailableProducts = (products: Products) => {
  const availableProducts: Products = []

  products.forEach((product) => {
    const { offers } = product.node.offers
    const isAvailable = offers.some((offer) => {
      return offer.availability === 'https://schema.org/InStock'
    })

    const variations = product.node.isVariantOf.hasVariant
    const availableVariations = filterAvailableVariations(variations)

    if (isAvailable || availableVariations.length) {
      availableProducts.push(product)
    }
  })

  return availableProducts
}

export const filterAvailableShelfProducts = (products: any) =>
  products?.edges?.filter((product: any) => {
    return product?.node?.offers?.offers.some((offer: any) => {
      return offer.availability === 'https://schema.org/InStock'
    })
  })

export const filterAvailableSearchProducts = (products: any) =>
  products?.filter((product: any) => {
    return product?.offers?.offers?.some((offer: any) => {
      return offer.availability === 'https://schema.org/InStock'
    })
  })
